import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectActivityInformationInTimeframe = async ({
  businessId,
  fromDate,
  toDate,
}) => {
  const apiPath = `business/${businessId}/active-projects/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
